import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    infoText: {
        marginBottom: '10px',
        fontSize: theme.fontSizes.bodySize,
    },
}));
